import * as types from "constants/actionTypes";
import * as Rx from "rxjs";
const { Observable } = Rx;
const { of, ajax } = Observable;
import * as actions from "actions/messageActions";
const apiUrls = require("constants/apiUrls");
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {
  //Messaging api grant
  getUserChannelGrant: (token, store) => {
    const wowHeaders = wowCustomHeader(store.getState());

    return ajax({
      url: apiUrls.USER_CHANNEL_GRANT_URL,
      method: "get",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + token
      }
    });
  },

  //Appian grant
  getUserChannelGrantAppian: (token, techId) => {
    const data = { channelId: techId };

    return ajax({
      url: apiUrls.USER_CHANNEL_GRANT_APPIAN_URL,
      method: "post",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      body: JSON.stringify(data),
      headers: {
        authorization: "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },

  updateCustomerEmail: (request, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: apiUrls.UPDATE_CUSTOMER_EMAIL_URL,
      method: "post",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + accessToken
      }
    });
  }
};

//Messaging Api
export const getUserChannelGrantEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.USER_CHANNEL_GRANT_STARTED).mergeMap(action =>
    call(api.getUserChannelGrant, action.token, store)
      .map(payload => {
        return actions.userChannelGrantFinished(payload, action.token);
      })
      .catch(error => of(actions.userChannelGrantFailed(error)))
  );
//appian
export const getUserChannelGrantAppianEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.USER_CHANNEL_GRANT_APPIAN_STARTED).mergeMap(action =>
    call(api.getUserChannelGrantAppian, action.token, action.techId)
      .map(payload => {
        return actions.userChannelGrantAppianFinished(payload.response.channel, action.techId);
      })
      .catch(error => of(actions.userChannelGrantAppianFailed(error)))
  );




// WEBPACK FOOTER //
// ./src/epics/messageEpics.js